import axios from "axios";

export default axios.create({
    baseURL: "/api", // process.env.API_URL ? process.env.API_URL :
    timeout: 20000,
    headers: {
        "Content-type": "application/json",
    },
});
